interface Props {
  [key: string]: any
}
function EnvelopeThinIcon(props: Props): React.ReactElement {
  const { pathClassName, ...rest } = props
  return (
    <svg fill="none" viewBox="0 0 20 16" {...rest} xmlns="http://www.w3.org/2000/svg">
      <path
        className={pathClassName ? `stroke-current ${pathClassName}` : ''}
        d="M0.980225 3.94598L8.81741 9.17078C9.14387 9.38859 9.52753 9.50482 9.91998 9.50482C10.3124 9.50482 10.6961 9.38859 11.0226 9.17078L18.8597 3.94598H0.980225ZM2.96684 14.8724H16.8731C17.4 14.8724 17.9053 14.6631 18.2779 14.2905C18.6504 13.9179 18.8597 13.4126 18.8597 12.8857V2.95268C18.8597 2.4258 18.6504 1.92049 18.2779 1.54793C17.9053 1.17537 17.4 0.966064 16.8731 0.966064H2.96684C2.43996 0.966064 1.93465 1.17537 1.56209 1.54793C1.18953 1.92049 0.980225 2.4258 0.980225 2.95268V12.8857C0.980225 13.4126 1.18953 13.9179 1.56209 14.2905C1.93465 14.6631 2.43996 14.8724 2.96684 14.8724Z"
        stroke="none"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}

export default EnvelopeThinIcon
